import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

window.onload = () => {
	if (document.getElementById('find-location')) {
		ReactDOM.createRoot(
			document.getElementById('find-location') as HTMLElement
		).render(
			<React.StrictMode>
				<App />
			</React.StrictMode>
		);
	}
};
